<template>
  <div
    class="brand info-con infinite-list"
    v-infinite-scroll="loadFontByPage"
    style="overflow-y: auto"
    :infinite-scroll-delay="500"
    :infinite-scroll-distance="90"
  >
    <div class="nav-title">
      <div class="tt-left">
        <h2>
          品牌管理

          <el-popover
            placement="bottom"
            width="400"
            trigger="hover"
            popper-class="member-popover"
          >
            <div class="common-introduce">
              <p>
                可以上传品牌相关的素材，供团队成员快速使用，保证所有设计都符合统一的品牌规范。
              </p>
              <p>
                您可以上传品牌Logo和字体，设置品牌颜色。这些资源都将存储在云端，不论在何时何地都可以轻松获取。
              </p>
            </div>
            <span slot="reference" class="iconfont icon-doubt"></span>
          </el-popover>
        </h2>
      </div>
    </div>

    <div class="brand-con">
      <logo-template ref="logo" :BrandInfo="BrandInfo" @getData="getData" />
      <color-template ref="color" :BrandInfo="BrandInfo" @getData="getData" />
      <font-template
        ref="font"
        :BrandInfo="BrandInfo"
        :FontsInfo="FontsInfo"
        @getData="getData"
        @getFontData="getFontData"
        @pagereset="pagereset"
      />
      <div class="loading-icon" v-show="fontisloading">
        <span class="el-icon-loading"></span>
        <span class="images-request-tip">正在加载</span>
      </div>
    </div>
  </div>
</template>

<script>
import { Brand } from "@/config/axios/new_api";
import LogoTemplate from "./logoTemplate.vue";
import ColorTemplate from "./colorTemplate.vue";
import fontTemplate from "./fontTemplate.vue";
export default {
  components: {
    LogoTemplate,
    ColorTemplate,
    fontTemplate,
  },
  name: "Brand",
  data() {
    return {
      FontsInfo: {
        fonts: [],
      },
      logoList: [],
      colorList: [],
      info: [],
      fontB: {},
      fontT: {},
      BrandInfo: {},
      fontisloading: true,
      loaded: false,
      page: 1,
      pagesize: 20,
    };
  },
  created() {
    this.getData();
    this.getFontData();
  },
  methods: {
    getData(include = "colors,logos") {
      Brand.brands({
        include
      }).then((res) => {
        if (res.status === 1) {
          let { data } = res;
          let { colors, font_b, font_t, fonts, logos } = data.current_team;
          if (colors) {
            this.colorList = colors;
          }
          if (fonts) {
            this.fontB = font_b;
            this.fontT = font_t;
            this.fontList = fonts;
          }
          if (logos) {
            this.logoList = logos;
          }

          this.BrandInfo = data.current_team;
        }
      });
    },
    getFontData(include = "fonts,font_t") {
      Brand.brands({
        include,
        page: this.page,
        page_size: this.pagesize,
      })
        .then((res) => {
          if (res.status === 1) {
            let { data } = res;
            let { current_team } = data;

            //this.fontisloading = false;
            if (current_team.fonts) {
              let fonts = current_team.fonts;
              if (this.page >= Math.ceil(fonts.total / fonts.page_size)) {
                this.loaded = true;
                this.fontisloading = false;
              }

              this.$set(this.FontsInfo, "font_t", current_team.font_t);
              this.$set(this.FontsInfo, "font_b", current_team.font_b);
              this.$set(this.FontsInfo, "fonts", [
                ...this.FontsInfo.fonts,
                ...fonts.data,
              ]);
            }
          } else {
            this.loaded = true;
            this.fontisloading = false;
          }
        })
        .catch(() => {
          this.loaded = true;
          this.fontisloading = false;
        });
    },
    pagereset() {
      this.page = 1;
      this.fontisloading = true;
      this.loaded = false;
      this.$set(this.FontsInfo, "fonts", []);
      this.getFontData();
    },
    loadFontByPage() {
      if (this.loaded) {
        this.fontisloading = false;
        return;
      }

      this.fontisloading = true;
      this.page++;
      this.getFontData();
    },
  },
};
</script>

<style lang="scss">
.brand {
  h4 {
    font-size: 13px;
    font-weight: 400;
    color: #2d2d32;
    line-height: 52px;
    height: 52px;
  }
  ul {
    display: flex;
    flex-wrap: wrap;
    li {
      @include wh(120px, 120px);
      cursor: pointer;
      margin-right: 20px;
      &:first-child {
        position: relative;
        // overflow: hidden;
        border-radius: 6px;
      }
      .logo-uploader {
        @include wh(100%, 120px);
        text-align: center;
        position: relative;
        background: #f7f6f9;
        border-radius: 6px;
        transition: all 0.3s;
        &:hover {
          background: $hoverColor;
        }
        .icon-Addto {
          font-size: 49px;
          @include wh(120px, 120px);
          display: block;
          line-height: 120px;
          color: #aaaab1;
        }
        p {
          @include wh(100%, 17px);
          text-align: center;
          font-size: 12px;
          font-weight: 400;
          color: #3c3c43;
          line-height: 17px;
          position: absolute;
          left: 0;
          bottom: 6px;
        }
      }
    }
  }
}
.info-con {
  min-height: 100vh;
  height: 100vh;
}

.font-dialog {
  .el-dialog__header {
    height: 104px;
  }

  .el-dialog {
    height: 382px;
  }
}

.loading-icon {
  margin-top: 40px;
  margin-bottom: 40px;

  span.el-icon-loading {
    font-size: 24px;
    color: #999999;
  }
  @include flex();
  @include justify-content(center);
  @include align-item(center);
  .images-request-tip {
    padding-left: 8px;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #999999;
    line-height: 22px;
  }
}
</style>
